import React from 'react';
import PropTypes from 'prop-types';
import { 
  ButtonGroup,
  Button
 } from 'reactstrap';
 import moment from 'moment';
import TimeFormatter from '../../../commons/TimeFormatter';

const SelectButtons = (props) => {

  const selectButtonStyle = {
    margin: '15px',
    zIndex: 0
  };

  const addButtonStyle = {
    display: 'block',
    margin: 'auto',
    width: '5%',
  };

  const buttonGroupStyle = {
    display: 'block',
    margin: 'auto',
    width: '80%',
  };

  return (
    <React.Fragment>
      <ButtonGroup style={buttonGroupStyle}>
        {props.datas && props.datas.map( data => 
          <Button key={data.id} style={selectButtonStyle} size="sm" outline color="secondary" onClick={e => props.selectDay(data.id)} active={props.selectedDays.includes(data.id)}>
            <p>{TimeFormatter.format(data.day, "ddd").toUpperCase()}</p>
            <p>{TimeFormatter.formatDate(data.day)}</p>
          </Button>
        )}
      </ButtonGroup>
      <div style={addButtonStyle}>
        <Button  color="success" onClick={e => props.addWeek()}>
          <i className="fa fa-plus" ></i>
        </Button>
      </div>
    </React.Fragment>
  );
};

SelectButtons.propTypes = {
  datas: PropTypes.array.isRequired,
  addWeek: PropTypes.func.isRequired,
  selectDay: PropTypes.func.isRequired,
  selectedDays: PropTypes.array.isRequired
};

export default SelectButtons;

